module.exports = __webpack_public_path__ + "img/increased-satisfaction.ff6de26.png";